/**
 * Dit is een component die tussen drie keuzes toggled, elke aanpassing gaat naar de callback
 * settings bevat de gegevens
 */


import React from "react";

export class ThreeToggle extends React.Component {
    constructor(props) {
        super(props);

        this.state =
            {
                "selected":this.props.selected
            }
        this.toggleClicked = this.toggleClicked.bind(this);
    }

    toggleClicked(p_new_selected)
    {
        this.setState({"selected":p_new_selected});
       this.props.callback(p_new_selected);
    }

    render()
    {

        return (
            <div >
                {this.state.selected == this.props.first_value &&
                    (
                        <>
                <a href="javascript:void(0)"  onClick={() => this.toggleClicked(this.props.first_value)} className={"button_toggle"}><img src={"/digibord/assets/svgs/checked_red.svg"} style={{"width":"25px"}}  /> {this.props.first_label}</a>
                            <a href="javascript:void(0)"  onClick={() => this.toggleClicked(this.props.second_value)} className={"button_toggle"}><img src={"/digibord/assets/svgs/unchecked_red.svg"} style={{"width":"25px"}}  /> {this.props.second_label}</a>
                            <a href="javascript:void(0)"  onClick={() => this.toggleClicked(this.props.third_value)} className={"button_toggle"}><img src={"/digibord/assets/svgs/unchecked_red.svg"} style={{"width":"25px"}}  /> {this.props.third_label}</a>
                        </>
                    )}

                {this.state.selected == this.props.second_value &&
                    (
                        <>
                            <a href="javascript:void(0)"  onClick={() => this.toggleClicked(this.props.first_value)} className={"button_toggle"}><img src={"/digibord/assets/svgs/unchecked_red.svg"} style={{"width":"25px"}}  /> {this.props.first_label}</a>
                            <a href="javascript:void(0)"  onClick={() => this.toggleClicked(this.props.second_value)} className={"button_toggle"}><img src={"/digibord/assets/svgs/checked_red.svg"} style={{"width":"25px"}}  /> {this.props.second_label}</a>
                            <a href="javascript:void(0)"  onClick={() => this.toggleClicked(this.props.third_value)} className={"button_toggle"}><img src={"/digibord/assets/svgs/unchecked_red.svg"} style={{"width":"25px"}}  /> {this.props.third_label}</a>
                        </>
                    )}


                {this.state.selected == this.props.third_value &&
                    (
                        <>
                            <a href="javascript:void(0)"  onClick={() => this.toggleClicked(this.props.first_value)} className={"button_toggle"}><img src={"/digibord/assets/svgs/unchecked_red.svg"} style={{"width":"25px"}}  /> {this.props.first_label}</a>
                            <a href="javascript:void(0)"  onClick={() => this.toggleClicked(this.props.second_value)} className={"button_toggle"}><img src={"/digibord/assets/svgs/unchecked_red.svg"} style={{"width":"25px"}}  /> {this.props.second_label}</a>
                            <a href="javascript:void(0)"  onClick={() => this.toggleClicked(this.props.third_value)} className={"button_toggle"}><img src={"/digibord/assets/svgs/checked_red.svg"} style={{"width":"25px"}}  /> {this.props.third_label}</a>
                        </>
                    )}
            </div>
        )

    }
}
